import { ArrowUpRight, Headset } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { presetRequest } from "./QuoteSection";

export default function ProcurementDesk() {
  return (
    <section id="procurement-desk" data-testid="procurement-desk-section" className="relative py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="relative rounded-2xl border border-gold/25 bg-gradient-to-br from-gold/[0.07] via-transparent to-transparent p-8 md:p-14 overflow-hidden">
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-gold/10 blur-[100px] pointer-events-none" />
            <SectionTag number="12" label="Procurement Desk" />
            <div className="flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
              <div className="max-w-2xl">
                <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white">
                  Ajemi <span className="text-gold">Procurement Desk.</span>
                </h2>
                <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed">
                  A dedicated point of coordination for petroleum procurement requirements —
                  built for customers with significant or recurring needs. One desk for your
                  sourcing, comparison, documentation and delivery coordination.
                </p>
              </div>
              <button
                data-testid="procurement-desk-btn"
                onClick={() => presetRequest({ type: "recurring", note: "Procurement Desk enquiry" })}
                className="group shrink-0 inline-flex items-center gap-3 bg-gold text-ink font-outfit font-medium rounded-full pl-7 pr-2.5 py-2.5 hover:bg-goldbright hover:shadow-[0_0_40px_rgba(217,164,65,0.45)] transition-all duration-300"
              >
                <Headset className="w-4 h-4" />
                Contact the Procurement Desk
                <span className="bg-ink/10 rounded-full p-2 group-hover:rotate-45 transition-transform duration-300">
                  <ArrowUpRight className="w-4 h-4" />
                </span>
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
